/**
 * @fileoverview Settings route definitions for AI and other application settings.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const AISettingsPage = lazy(() =>
  import('../../features/settings/pages/AISettingsPage').then((m) => ({ default: m.AISettingsPage }))
);

export const settingsRoutes: RouteObject[] = createRoutes([
  { path: 'settings/ai', Component: AISettingsPage },
]);
